import { ELITE_MODELS, ICameraInfo } from '@thingsw/pitta-modules';
import { useMemo } from 'react';

const useEliteModel = (camera: ICameraInfo | undefined) => {
  const isEliteModel = useMemo(() => {
    if (!camera) return false;

    return ELITE_MODELS.includes(camera.model);
  }, [camera]);

  return {
    isEliteModel,
  };
};

export default useEliteModel;
